import { Link } from 'react-router-dom';
import { useAuth } from '@/App';
import { Car, LogOut, LayoutDashboard, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const Navbar = () => {
  const { user, logout } = useAuth();

  return (
    <nav className="sticky-header" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">
            <Car className="w-8 h-8 text-primary" />
            <span className="text-2xl font-bold tracking-tight" style={{ fontFamily: 'Cabinet Grotesk' }}>
              Amjed Tours
            </span>
          </Link>

          <div className="flex items-center gap-6">
            <Link to="/cars" className="font-medium hover:text-primary transition-colors" data-testid="navbar-browse-cars">
              Browse Cars
            </Link>
            <Link to="/blog" className="font-medium hover:text-primary transition-colors" data-testid="navbar-blog">
              Blog
            </Link>
            
            {user ? (
              <>
                <Link to="/dashboard" className="flex items-center gap-2 font-medium hover:text-primary transition-colors" data-testid="navbar-dashboard">
                  <LayoutDashboard className="w-4 h-4" />
                  Dashboard
                </Link>
                {user.role === 'admin' && (
                  <Link to="/admin" className="flex items-center gap-2 font-medium hover:text-primary transition-colors" data-testid="navbar-admin">
                    <Shield className="w-4 h-4" />
                    Admin
                  </Link>
                )}
                <Button
                  onClick={logout}
                  variant="ghost"
                  size="sm"
                  className="flex items-center gap-2"
                  data-testid="navbar-logout-btn"
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="navbar-login-btn">
                  <Button variant="ghost" size="sm">Login</Button>
                </Link>
                <Link to="/register" data-testid="navbar-register-btn">
                  <Button className="btn-primary" size="sm">Sign Up</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
